import { render, staticRenderFns } from "./CourseMaterial.vue?vue&type=template&id=ce46691a&scoped=true&"
import script from "./CourseMaterial.vue?vue&type=script&lang=js&"
export * from "./CourseMaterial.vue?vue&type=script&lang=js&"
import style0 from "./CourseMaterial.vue?vue&type=style&index=0&id=ce46691a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce46691a",
  null
  
)

export default component.exports